import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'any'
})
export class SpeakerService {

	public listData: any[] = [];
	public isLoading = false;
	public openingBalance = 0;
	public showOpeningBalance = false;
	public displayColumns: any[] = [];
	public displayHeaders: any[] = [];
	public allIds: any[] = [];
	public model = '';
	public pageIndex = 0;
	public pageSize = 10;
	public length = 0;
	public sortQuery = 'id:1';
	public filterQuery = '';
	public activeView = true;
	public actionColumnLabel = '';
	public showActionColumn = false;
	/** When set, list-container's Export button POSTs to this backend endpoint
	 *  and downloads the returned xlsx blob instead of generating one client-side. */
	public exportBackend: {
		model: string;
		route: string;
		payload: any;
		filename: string;
	} | null = null;

	constructor() { }

	// --- List data ---
	private listDataSubject = new Subject<any>();
	listData$ = this.listDataSubject.asObservable();

	// --- Pagination / sort change ---
	private paginationChangeSubject = new Subject<{ pageIndex: number; pageSize: number; sortQuery: string }>();
	paginationChange$ = this.paginationChangeSubject.asObservable();

	// --- Active toggle ---
	private activeViewSubject = new Subject<boolean>();
	activeView$ = this.activeViewSubject.asObservable();

	// --- Bulk action ---
	private bulkActionSubject = new Subject<{ selectedIds: (number | string)[]; status: 'active' | 'inactive' }>();
	bulkAction$ = this.bulkActionSubject.asObservable();

	// --- Clear selection ---
	private clearSelectionSubject = new Subject<void>();
	clearSelection$ = this.clearSelectionSubject.asObservable();

	// --- Row click ---
	private rowClickSubject = new Subject<any>();
	rowClick$ = this.rowClickSubject.asObservable();

	// --- Action column click ---
	private actionClickSubject = new Subject<any>();
	actionClick$ = this.actionClickSubject.asObservable();

	setListData(data: any[], length: number, pageIndex: number, pageSize: number, allIds: number[] = [], sortQuery = '') {
		this.length = length;
		this.pageIndex = pageIndex;
		this.pageSize = pageSize;
		this.listData = data;
		this.sortQuery = sortQuery || this.sortQuery;
		this.allIds = allIds;

		this.listDataSubject.next({ data, length, pageIndex, pageSize, sortQuery: this.sortQuery, allIds });
	}

	emitPaginationChange(pageIndex: number, pageSize: number, sortQuery: string) {
		if (sortQuery) {
			this.sortQuery = sortQuery;
		}
		this.paginationChangeSubject.next({ pageIndex, pageSize, sortQuery: this.sortQuery });
	}

	setActiveView(active: boolean) {
		this.activeView = active;
		this.activeViewSubject.next(active);
	}

	emitBulkAction(payload: { selectedIds: (number | string)[]; status: 'active' | 'inactive' }) {
		this.bulkActionSubject.next(payload);
	}

	emitClearSelection() {
		this.clearSelectionSubject.next();
	}

	emitRowClick(payload: any) {
		this.rowClickSubject.next(payload);
	}

	emitActionClick(row: any) {
		this.actionClickSubject.next(row);
	}
}
